export default __webpack_public_path__ + "static/media/icn_attachment.bae465c3.svg";